class BDProductMedia extends HTMLElement {
  connectedCallback() {
    const grid = this.closest('[data-product-grid-content]');
    if (!grid) return;

    this.variantPicker = grid.querySelector('variant-picker');
    if (!this.variantPicker) return;

    this._onVariantUpdate = this.handleVariantUpdate.bind(this);

    // Use the event you ARE receiving
    this.variantPicker.addEventListener('variant:update', this._onVariantUpdate);

    console.log('BDProductMedia: listener attached to variant-picker', this.variantPicker);

 this.addEventListener('click', (e) => {
    const zoomEl = e.target.closest('[data-zoom]');
    if (!zoomEl) return;

    this.#openLightboxFromZoom(zoomEl);
  });

  }

  disconnectedCallback() {
    if (this.variantPicker) {
      this.variantPicker.removeEventListener('variant:update', this._onVariantUpdate);
    }
  }

handleVariantUpdate(event) {
  console.log('VARIANT UPDATE FIRED', event);

  // ⭐ Only use DOM checked input — stable, safe, guaranteed
  const checked = this.variantPicker.querySelector('input[data-variant-id]:checked');
  const variantId = checked?.dataset.variantId;

  console.log('Resolved variantId:', variantId);

  if (!variantId) {
    console.warn('BDProductMedia: Could not resolve variantId');
    return;
  }

  this.fetchUpdatedMediaSection(variantId);
}


  getVariantIdFromDOM() {
    // Horizon stores the selected variant in the checked input
    const checked = this.variantPicker.querySelector('input[data-variant-id]:checked');
    return checked?.dataset.variantId;
  }

  async fetchUpdatedMediaSection(variantId) {
    console.log('fetch', variantId);
    const sectionId = this.closest('[data-section-id]')?.dataset.sectionId;
    if (!sectionId) {
      console.warn('BDProductMedia: No section_id found');
      return;
    }

    const url = `${window.location.pathname}?variant=${variantId}&section_id=${sectionId}`;
    console.log('BDProductMedia: Fetching own section:', url);

    const response = await fetch(url);
    if (!response.ok) return;

    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    const updated = doc.querySelector('bd-product-media');
    if (!updated) {
      console.warn('BDProductMedia: Updated media not found in fetched HTML');
      return;
    }

    this.updateFromHtml(updated);
    
  }
updateFromHtml(updated) {
  // Fade out
  this.classList.add('is-updating');

  requestAnimationFrame(() => {
    setTimeout(() => {
      // Destroy old slider
      this.querySelector('bd-slider')?.destroySlider?.();

      // Swap HTML
      this.innerHTML = updated.innerHTML;

      // Re-init slider
      const slider = this.querySelector('bd-slider');
      slider?.initSlider?.();

      // Reset Embla to index 0
      slider?.embla?.scrollTo(0, false);

      // ⭐ Bind loaders AFTER DOM swap
      bindMediaLoaders(this);

      // Fade in
      requestAnimationFrame(() => {
        this.classList.remove('is-updating');
      });
    }, 150);
  });
}


#openLightboxFromZoom(zoomEl) {
  const slider = this.querySelector('bd-slider');
  const lightbox = document.querySelector('bd-lightbox'); // ⭐ updated

  const slides = slider.embla.slideNodes();

  const images = slides.map(s => {
    const img = s.querySelector('[data-zoom] img');
    return img?.dataset.zoomSrc || img?.src;
  });

  const index = slides.findIndex(s => s.contains(zoomEl));

  lightbox.open(images, index);
}



}

customElements.define('bd-product-media', BDProductMedia);
